export default {"src":"/_next/static/media/settings.13a6404f.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};